
<template>
  <PostEditPage :view="'Edit'" :serviceId="finalServiceId" />
</template>

<script>
import { useRoute } from "vue-router";
import PostEditPage from './PostEditPage.vue'
import { ref, computed } from "vue";

export default {
  props: {
    serviceId: { type: String, default: null }, // optional prop
  },
  components: { PostEditPage },
  setup(props) {
    const route = useRoute();

    // Compute the final serviceId: prefer prop, fallback to route query
    const finalServiceId = computed(() => {
      return props.serviceId || route.query.servicesID || null;
    });

    console.log("Final serviceId:", finalServiceId.value);

    return { finalServiceId };
  },
};
</script>
